import styled from "styled-components";

export const BtnImage = styled.div<{isVisibleFiltersPanel: boolean}>`
  margin-left: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-style: solid;
  border-width: 1px;
  border-color: ${(props) =>
    props.isVisibleFiltersPanel ? "#0078D2" : "rgba(0,0,0,0)"};
  background-color: ${(props) =>
    props.isVisibleFiltersPanel ? "#22272B" : "rgba(0,0,0,0)"};
  transition: border 0.3s ease;
  border-radius: 7px;
`;
